import React from 'react';
import PropTypes from 'prop-types';

const FacebookIcon = ({ width = 11, height = 18, className = '' }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 10.13 19.43'
            height={height}
            width={width}
            className={className}
        >
            <g id='Layer_2' data-name='Layer 2'>
                <g id='Layer_1-2' data-name='Layer 1'>
                    <path
                        fill='#fff'
                        className='cls-1'
                        d='M10.13,3.25c-.68,0-1.3,0-1.92,0A1.47,1.47,0,0,0,6.59,4.92c0,.71,0,1.42,0,2.23h3.46l-.43,3.4h-3v8.88H3V10.6H0V7.19H3c0-1,0-1.91,0-2.81A4.15,4.15,0,0,1,7.36,0c.91,0,1.82,0,2.77,0Z'
                    />
                </g>
            </g>
        </svg>
    );
};

FacebookIcon.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    className: PropTypes.string
};

export default FacebookIcon;
